import { AppConfig, hasValidCmsConfig, hasValidNewsletterConfig } from './cmsConfig';

export type { AppConfig };
export { hasValidCmsConfig, hasValidNewsletterConfig };

const isTemplateString = (value: string | undefined): boolean => {
  return !value || value.startsWith('${');
};

export const getRuntimeConfig = (): AppConfig => {
  const runtimeConfig = window.__APP_CONFIG__;
  
  return {
    CMS_API_URL: (!isTemplateString(runtimeConfig?.CMS_API_URL) && runtimeConfig?.CMS_API_URL) || import.meta.env.VITE_CMS_API_URL || '',
    CMS_FILE_API_URL: (!isTemplateString(runtimeConfig?.CMS_FILE_API_URL) && runtimeConfig?.CMS_FILE_API_URL) || import.meta.env.VITE_CMS_FILE_API_URL || '',
    CMS_API_PUBLIC_KEY: (!isTemplateString(runtimeConfig?.CMS_API_PUBLIC_KEY) && runtimeConfig?.CMS_API_PUBLIC_KEY) || import.meta.env.VITE_CMS_API_PUBLIC_KEY || '',
    TENANT_NAME: (!isTemplateString(runtimeConfig?.TENANT_NAME) && runtimeConfig?.TENANT_NAME) || import.meta.env.VITE_TENANT_NAME || '',
    NEWSLETTER_FORM_KEY: (!isTemplateString(runtimeConfig?.NEWSLETTER_FORM_KEY) && runtimeConfig?.NEWSLETTER_FORM_KEY) || import.meta.env.VITE_NEWSLETTER_FORM_KEY || 'subscription',
  };
};
